<template>
  <div :class="$style.h5sdk" :style="{ backgroundImage: `url('${background}')` }">
    <!-- 手机登录 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.cellLoginVisible">
      <!-- <cell-register @back="redirectLogin" @register="handleCellRegister" @redirectArgument="redirectArgument"></cell-register> -->
      <cell-login 
        @redirectRegist="redirectRegist" 
        @redirectAccountLogin="redirectAccountLogin" 
        @redirectArgument="redirectArgument"
        @login="cellLogin"
        :hideRegister="hideRegister"
        ref="cellLogin"
      ></cell-login>
    </div>
    <!-- 快速注册 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.quickRegisterVisible">
      <quick-register
        @redirectAccountLogin="redirectAccountLogin"
        @redirectCellLogin="redirectCellLogin"
        @register="handleQuickRegister"
        @redirectArgument="redirectArgument"
      ></quick-register>
    </div>
    <!-- 登录 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.loginVisible">
      <Login @login="handleLogin" @redirectRegist="redirectRegist" @redirectForget="redirectForget" :hideRegister="hideRegister" @redirectArgument="redirectArgument" @redirectCellLogin="redirectCellLogin"></Login>
    </div>
    <!-- 忘记密码 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.resetVisible">
      <Reset @back="redirectLogin"></Reset>
    </div>
    <!-- 悬浮球 -->
    <Suspend v-if="userState.suspendVisible"></Suspend>
    <!-- 悬浮窗 -->

    <!-- 公告 -->
    <Affiche v-if="userState.afficheShow" @close="closeAffiche"></Affiche>
    <!-- 强更新活动 -->
    <!-- <ForceUpdate v-if="userState.forceUpdateVisible" @toLogin="toLogin"></ForceUpdate> -->
    <!-- 防沉迷 -->
    <AntiIndulged v-if="userState.antiIndulgedVisible" @notifyLogin="enterGame"></AntiIndulged>
    <!-- 支付 -->
    <Charge v-if="userState.chargeVisible" @close="closeChargeWindow"></Charge>
    <!-- 滑块验证 -->
    <Captcha :class="$style.captcha" v-show="userState.captchaVisible" @captchaInit="captchaInit"></Captcha>
    <!-- vip客服 -->
    <VipCustomer v-if="userState.vipVisible"></VipCustomer>
    <div :class="[$style.outer, background == '' ? $style.mask : '', $style.argument]" v-if="userState.argumentVisible">
      <Argument @redirectRegist="argumentReturn"></Argument>
    </div>
    <div :class="[$style.outer, background == '' ? $style.mask : '', $style.argumentTip]" v-if="argumentTipVisible">
      <ArgumentTip @agreeArgument="agreeArgument" @back="argumentTipVisible=false" @showArgument="redirectArgument"></ArgumentTip>
    </div>
    <FloatWindow v-if="userState.floatWindowVisible"></FloatWindow>
    <!-- 强制绑定手机 -->
    <ForceBindPhone v-if="userState.forceBindVisible" @close="closeForceBind" :normalTelBind="normalTelBind"></ForceBindPhone>
    <!-- 应用宝登录框 -->
    <!-- <YybLogin v-if="userState.yybLoginVisible"></YybLogin> -->
    <!-- iOS h5 他添加桌面提示 -->
    <iosTips v-if="userState.iosTips"></iosTips>
    <!-- 游戏frame -->
    <!--iframe :class="$style.gameFrame" name="gameFrame" src="https://dev-sdk-static.zhangyuqu.com/demo.html?t=7777" v-if="userState.gameVisible"></iframe -->
        <iframe :class="$style.gameFrame" name="gameFrame" src="https://dev-sdk-static.zhangyuqu.com/demo.html?t=7777" v-if="userState.gameVisible"></iframe>

    <!-- 活动页 -->
    <ActivityPage v-if="activityShowInfo.visible"></ActivityPage>
    <!-- 冻结账号强制下线弹窗 -->
    <ForceOffline v-if="userState.forceOfflineVisible"></ForceOffline>
    <!-- 收到优惠券提示 -->
    <!-- <VoucherHint v-if="voucherState.voucherHintVisible"></VoucherHint> -->
    <!-- 强更转移礼包 -->
    <UpdateGift v-if="userState.updateGiftVisible" @close="closeUpdateGift"></UpdateGift>
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="guideRemindVisible">
      <GuideRemind @close="closeGuideRemind"></GuideRemind>
    </div>
    <!-- 静默登录欢迎用户登录提示 -->
    <div :class="$style.hint" v-if="hintShow">
      用户（<span>{{ userState.username }}</span>），欢迎进入游戏。
    </div>
    <img :src="`${$cdnLink}/common/lead.png`" alt="" v-if="guideBrowserVisible" :class="$style.guideBrowser" @click="hideGuideBrowser">
  </div>
</template>
<script>
import QuickRegister from '@/components/login/RegisterV2/index.vue';
import CellLogin from '@/components/login/CellLogin/index.vue';
import Login from '@/components/login/LoginV2/index.vue';
import Suspend from './suspend.vue';
import Reset from '@/components/login/Forgetpswds/index.vue';
import Affiche from '@/components/login/Affiche/index.vue';
import AntiIndulged from './antiIndulged.vue';
import Charge from '@/components/charge/Charge/index.vue'
import Captcha from '@/components/login/Captcha/index.vue'
import VipCustomer from './vipCustomer.vue'
import Argument from '@/components/login/Argument/index.vue'
import FloatWindow from './floatWindow.vue'
import ForceBindPhone from '@/components/login/ForceBindPhone/index.vue'
import ActivityPage from './activityPage.vue'
import ForceOffline from './forceOffline.vue'
import UpdateGift from '@/components/update/Gift.vue'
import ArgumentTip from '@/components/login/ArgumentTip/index.vue'
import GuideRemind from '@/components/charge/GuideRemind.vue'

import iosTips from '@/components/iosTips.vue';

import { mapState } from 'vuex';
import { isAndroid,isSysName,getStorage,isSafari,isStandalone } from '@/libs/utils.js';
import {
  thirdPartyLogins,
  registJSInitial,
  innerPurchaseFunctionSuc,
  closeOrderFrame,
  checkOrderState,
  deviceFlip2H5,
  onBackPressed2H5,
  getInitialInfo
} from '@/bridge/AppJsBridge';
import { getAccount, getCellAccount, setStorage, saveCellAccount, delCellAccount } from '@/libs/utils';
import { CaptchaInit, CaptchaReset } from "@/libs/captcha";

export default {
  metaInfo() {
    return {
      title: this.$store.state.user.app_name, // 正确：使用箭头函数，可以访问 this
      meta: [
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
      ],
      link:[
        {rel:'apple-touch-icon-precomposed',href:'https://sdk-static.zhangyuqu.com/icon/app/slzs.png'}
      ],
    };
  },
  data() {
    return {
      registerCallback: '', // 暂存滑块验证成功后需要调用的回调方法名
      cellForm: {}, // 手机滑块注册时暂存表单信息
      normalTelBind: false, // 是登录后show_tel_bind
      argumentTipVisible: false, //协议提示
      argumentHandle: {
        method: '',
        params: {}
      },  // 显示勾选协议提示后点击同意进入游戏的回调
      hideRegister: true,
      pageName:"",
    }
  },
  created() {    
    // 标识使用手机号登录优先的sdk地址，涉及到悬浮窗换绑相关逻辑
    this.pageName = this.$store.state.user.app_name;
    localStorage.setItem('isV2Sdk', true);
    this.$store.commit('user/CHANGE_STATE', { loginVisible: true, cellLoginVisible: false });
    this.$store.commit('global/handleLinkParams', this.$route.query);
    this._handleType();
    if (this.$route.name == 'h5.silentLogin') {
      this.$store.commit('user/CHANGE_STATE', { loginVisible: false, cellLoginVisible: false });
      this.$setStorage('isSilentLogin', true);
    } else {
      this.$setStorage('isSilentLogin', false);
    }
    if (this.$route.name === 'h5.external') {
      this._externalInit();
      let iosTips = getStorage('iosTips');
      //let isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)> -1) ;
      console.log('------isSafari',isSafari());
    
      if('iphone' == isSysName() && !iosTips && isSafari() && !isStandalone() ){
        console.log('------isSysName',isSysName());
        this.$store.commit('user/CHANGE_STATE', { iosTips: true }, { root: true });
      }
    } else if (!isAndroid()) {

      let iosTips = getStorage('iosTips');
      //let isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)> -1) ;
      console.log('------isSafari',isSafari());
    
      if('iphone' == isSysName() && !iosTips && isSafari() && !isStandalone() ){
        console.log('------isSysName',isSysName());
        this.$store.commit('user/CHANGE_STATE', { iosTips: true }, { root: true });
      }

      this._iosInit();
    }
    this._handleSkin();
  },
  mounted() {
    this.$store.dispatch('user/getCacheState');
    this._bridgeInit();
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      voucherState: state => state.voucher,
      loginStatus: state => state.user.login_status,
      gameSrc: state => state.user.game_url,
      policyVisible: state => state.global.policyVisible,
      captchaStatus: state => state.user.captcha_status,
      activityShowInfo: state => state.activity.activity_show_info || {},
      background: state => state.user.background,
      guideRemindVisible: state => state.pay.guideRemindVisible,
      hintShow: state => state.user.silentHintShow,
      guideBrowserVisible: state => state.pay.guideBrowserVisible,
    })
  },
  watch: {
    // 初始化后监听captcha_status判断当前包是否开启滑块验证
    // captchaStatus(val) {
    //   if (val == '1') {
    //     this._captchaInit();
    //   }
    // }
  },
  components: {
    QuickRegister,
    CellLogin,
    Login,
    Suspend,
    Reset,
    Affiche,
    AntiIndulged,
    Charge,
    Captcha,
    VipCustomer,
    Argument,
    FloatWindow,
    ForceBindPhone,
    ActivityPage,
    ForceOffline,
    UpdateGift,
    ArgumentTip,
    GuideRemind,
    iosTips
  },
  methods: {
    _bridgeInit() {
      // 初始化客户端传过来的信息
      registJSInitial(async (e, cb) => {
        console.log('--- registJSInitial start ---')
        // ios h5通过链接获取设备参数，不会进这里
        let data = JSON.parse(e);
        const { user_info, jsDataStorage, third_sdk_status } = data;

        // 壳子缓存的用户列表不为空，则拿到用户列表
        if (user_info && user_info.length) {
          this.$store.commit('user/CHANGE_STATE', {
            userList: user_info,
            username: user_info[0].username,
            password: user_info[0].password
          });
        }
        // 存储传过来的信息
        this.$store.commit('user/CHANGE_STATE', {
          sdk_version: data.sdk_version,
          device_info: data.attributeReportParams,
          appkey: data.jh_app_id,
          channel: data.jh_channel,
          extra_data: JSON.stringify(data.extra_data),
          game_version: data.game_version,
          login_status: jsDataStorage || '',
          third_sdk_status: third_sdk_status || '',
          isEmulator: data.isEmulator,
          isInstallWeChat: data.isInstallWeChat,
          isInstallAlipay: data.isInstallAlipay,
        });

        // 强制正常登录
        if (third_sdk_status == 'false') {
          this.$store.commit('user/CHANGE_STATE', { login_status: 2 });
        }
        // 缓存信息
        const cacheList = [
          'login_status',
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status',
          'isEmulator',
          'isInstallWeChat',
          'isInstallAlipay'
        ];
        this.$store.dispatch('user/cacheState', cacheList);

        // 应用宝强制正常登录
        if (data.third_sdk_status === false) {
          setStorage('force_normal_login', 2);
        }

        this.$store.dispatch('user/getYsdkStatus', 1);
        this.$store.dispatch('user/affiche');
        this.silentLogin();
      });
      thirdPartyLogins((e, cb) => {
        console.log('--- third login start ---')
        let data = JSON.parse(e);
        if (data.isHuaWei) {
          // 针对华为审核不能存在第三方账号体系做处理
          this.$store.dispatch('user/huaweiThirdLogin');
        } else {
          this.$store.commit('user/CHANGE_STATE', { username: data.user_name, password: data.origncv });
          this.userState.loginStatus != 2 && this.$store.dispatch('user/login', true);
        }
      });
      // 应用宝内购
      innerPurchaseFunctionSuc(async (e, cb) => {
        console.log('--- 应用宝内购 ---')
        this.$store.commit('pay/CHANGE_STATE', { yyb_info: JSON.parse(e) });
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      });
      // 关闭订单窗口
      closeOrderFrame((e, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          orderIframeLink: '',
          orderShow: false,
          chargeOrNot: false
        });
        // 重复点击处理
        this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
      });
      // 查询订单结果
      checkOrderState((e, cb) => {
      
       
        const params = {
          code: 1,
          msg: 'ok',
        };
        window.frames['gameFrame'].postMessage({ action: 'orderCallback', params }, '*');
      
      
        this.$store.dispatch('pay/queryOrderResult');
      });
      // 手机翻转
      deviceFlip2H5((e, cb) => {
        const hidefloat = this.$getStorage('hidefloat');
        if (hidefloat) return;
        this.$store.commit('user/CHANGE_STATE', { suspendVisible: !this.$store.state.user.suspendVisible });
      })
      onBackPressed2H5((e, cb) => {
        if (this.userState.game_url) {
          this.$store.commit('user/CHANGE_STATE', {
            cellLoginVisible: false,
            quickRegisterVisible: false,
            loginVisible: false,
            resetVisible: false
          });
        }
        cb('onBackPressed2H5 success')
      })
    },
    _handleSkin() {
      const { skin } = this.$route.query;
      this.$setStorage('skin', skin || '');
    },
    async _iosInit() {
      const { initial, iosThirdPacket } = this.$route.query;
      if (iosThirdPacket) {
        // ios三方买包
        await this.$store.dispatch('user/initIosThirdDeviceData', this.$route.query);
      } else if (initial) {
        // ios 非jsbridge形式传递设备信息处理
        await this.$store.dispatch('user/initDeviceData', this.$route.query);
      }
      getInitialInfo((e) => {
        const { extra_data } = this.$store.state.user;
        const _extraData = JSON.parse(extra_data);
        _extraData.caid = e.caid;
        this.$store.commit('user/CHANGE_STATE', { extra_data: JSON.stringify(_extraData) });
      })
      this.silentLogin();
    },
    // 使用安卓参数，外链形式提供给玩家在浏览器游戏初始化方式
    _externalInit() {

      this.$store.dispatch('user/initExternalData', this.$route.query);
      this.$setStorage('externalLogin', true);
      this.hideRegister = true;
      this.$store.commit('user/CHANGE_STATE', { loginVisible: true, cellLoginVisible: false });
    },
    captchaInit() {
      CaptchaInit(
        "captcha",
        (data) => {
          this.$store.commit("user/CHANGE_STATE", { captchaVisible: false });
          CaptchaReset()
          this.registerCallback && this[this.registerCallback](data);
        },
        (err) => {
          CaptchaReset()
          console.log(err);
        }
      );
    },
    _handleType() {
      const v2LoginType = localStorage.getItem('v2LoginType');
      const normalUserList = getAccount() || [];
      const cellUserList = getCellAccount() || [];
      // 先兼容老包用户有账号缓存无手机号缓存情况下，默认显示账号登陆 然后判断若上次玩家登录为账号登陆，则显示账号登陆
      if ((!v2LoginType && !cellUserList.length && normalUserList.length) || v2LoginType == 'normal') {
        this.redirectAccountLogin();
      }
    },
    agreeArgument() {
      const { method, params } = this.argumentHandle;
      this.argumentTipVisible = false;
      this[method]({
        ...params,
        agreementState: true
      })
    },
    // 滑块设置回调
    setRegisterCallback(cb, form) {
      this.registerCallback = cb;
      if (form) this.cellForm = form
    },
    async toLogin() {
      const r = await this.$store.dispatch('user/login');
      localStorage.setItem('v2LoginType', 'normal');
      localStorage.setItem('agreement_flag', 1);
      // 特殊情况
      if (r.content.login_status) {
        this.$store.commit('global/clearLoading')
        return;
      }

      // 登录后强制绑定手机判断
      const { force_bind_tel, show_tel_bind } = r.content;
      if ([1, 2, 3].includes(force_bind_tel) || show_tel_bind) {
        if (show_tel_bind && ![1, 2, 3].includes(force_bind_tel)) this.normalTelBind = true
        // force_bind_tel为2时提示用户绑定手机，但可正常进入游戏
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: true });
        this.$store.commit('global/clearLoading')
        return;
      }
      // 继续处理vip和防沉迷
      this.handleLoginInfo()
    },
    async cellLogin(form) {
      if (!form.agreementState) {
        this.argumentHandle = {
          method: 'cellLogin',
          params: form
        }
        this.argumentTipVisible = true;
        return;
      }
      try {
        const r = await this.$store.dispatch('user/cellLogin', form);
        localStorage.setItem('v2LoginType', 'cell');
        localStorage.setItem('agreement_flag', 1);
        // 存储手机登录凭证
        if (r.content.login_credential && !form.credential) {
          saveCellAccount(form.tel_num, r.content.login_credential);
        }
  
        // 特殊情况
        if (r.content.login_status) {
          this.$store.commit('global/clearLoading');
          return;
        }
        // 登录后强制绑定手机判断
        const { force_bind_tel } = r.content;
        if ([1, 2, 3].includes(force_bind_tel)) {
          // force_bind_tel为2时提示用户绑定手机，但可正常进入游戏
          this.$store.commit('user/CHANGE_STATE', {
            forceBindVisible: true,
          });
          this.$store.commit('global/clearLoading');
          return;
        }
        this.handleLoginInfo();
      } catch (error) {
        if (error.ret && error.ret === 194) {
          delCellAccount(form.tel_num)
          setTimeout(() => {
            this.$refs.cellLogin.getCellList(1);
          });
        }
      }
    },
    handleLoginInfo() {
      // vip判断
      this.$store.dispatch('user/checkVip');

      // 防沉迷判断
      this.$store.dispatch('user/checkAntiIndulged').then(() => {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: true });
        this.$store.commit('global/clearLoading')
      }).catch(() => this.enterGame());
    },
    closeForceBind(type) {
      const { force_bind_tel } = this.userState
      if (!type && force_bind_tel == 1) {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
      } else {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
        this.$store.commit('global/showLoading')
        this.handleLoginInfo()
      }
    },
    enterGame() {
      // 如果进了防沉迷流程，关闭防沉迷窗口使用
      if (this.userState.antiIndulgedVisible) {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: false });
        this.$store.commit('global/showLoading')
      }
      if (this.userState.h5Preload) {
        // 如果开启了h5预加载，登录成功后再调用研发回调
        this.$store.dispatch('message/notifyLogin');
      } else {
        this.$store.dispatch('message/monitorInit')
        this.$store.commit('user/CHANGE_STATE', { gameVisible: true });
      }
    },
    handleLogin(form) {
      if (form && !form.agreementState) {
        this.argumentHandle = {
          method: 'handleLogin',
          params: form
        }
        this.argumentTipVisible = true;
        return;
      }
      this.$store.commit('user/CHANGE_STATE', form);
      this.toLogin();
    },
    redirectRegist() {
      this.$store.dispatch('user/refreshOaid');
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
        loginVisible: false,
        quickRegisterVisible: true,
        cellLoginVisible: false,
      });
    },
    redirectCellLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: false,
        cellLoginVisible: true,
        quickRegisterVisible: false,
        argumentVisible: false,
      });
    },
    redirectAccountLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: true,
        cellLoginVisible: false,
        quickRegisterVisible: false,
        argumentVisible: false,
      });
    },
    argumentReturn() {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
      });
    },
    redirectForget() {
      this.$store.commit('user/CHANGE_STATE', {
        loginVisible: false,
        resetVisible: true
      });
    },
    redirectLogin() {
      this.$store.commit('user/CHANGE_STATE', {
        cellLoginVisible: false,
        quickRegisterVisible: false,
        resetVisible: false,
        loginVisible: true
      });
    },
    async handleQuickRegister(form) {
      if (!form.agreementState) {
        this.argumentHandle = {
          method: 'handleQuickRegister',
          params: {}
        }
        this.argumentTipVisible = true;
        return;
      }
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit('user/CHANGE_STATE', {
          captchaVisible: true
        });
        this.setRegisterCallback('captchaQuickRegister');
        return;
      }
      await this.$store.dispatch('user/quickRegister');
      this.toLogin();
    },
    async handleCellRegister(form) {
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit('user/CHANGE_STATE', {
          captchaVisible: true
        });
        this.setRegisterCallback('captchaCellRegister', form);
        return;
      }
      await this.$store.dispatch('user/cellRegister');
      this.toLogin();
    },
    closeAffiche() {
      this.$store.commit('user/CHANGE_STATE', { afficheShow: false });
    },
    closeChargeWindow() {
      this.$store.commit('user/CHANGE_STATE', { chargeVisible: false });
    },
    closeUpdateGift() {
      this.$store.commit('user/CHANGE_STATE', { updateGiftVisible: false });
    },
    closeGuideRemind() {
      this.$store.commit('pay/CHANGE_STATE', { guideRemindVisible: false });
    },
    redirectArgument(type) {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: true,
        argumentType: type
      });
    },
    hideGuideBrowser() {
      this.$store.commit('pay/CHANGE_STATE', {
        guideBrowserVisible: false
      });
    },
    /**
    * 带滑块验证的快速注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaQuickRegister (validData) {
      await this.$store.dispatch('user/quickRegister', validData);
      await this.toLogin();
    },
    /**
    * 带滑块验证的手机注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaCellRegister (validData) {
      await this.$store.dispatch('user/cellRegister', { ...this.cellForm, validData });
      await this.toLogin();
    },
    async silentLogin() {
      if (!this.$getStorage('isSilentLogin')) return;     
      await this.$store.dispatch('user/silentLogin');
      // 公告
      const { affiche_info } = this.userState;
      if (affiche_info && affiche_info.login_state == 0) {
        return;
      }
      this.handleLoginInfo();
    }
  }
}

</script>

<style lang="scss" module>
.h5sdk {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .gameFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    /* background: #000000; */
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }

  .mask {
    background: rgba(0, 0, 0, 0.6);
  }
  .outer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .argumentTip {
    z-index: 99;
  }
  .argument {
    z-index: 100;
  }
  .captcha {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 350px;
    height: 270px;
  }
  .hint {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    padding: 5px 15px;
    font-size: 14px;
    background-color: #ededf9;
    > span {
      color:  #FF3B36;
    }
  }
  .guideBrowser {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }
}
</style>
